class ApiMethods {

    /**
     *
     */
    addAccessTokenAuthorization(headers = {}) {
        if (config.accessToken) {
            return this.addAuthHeader(config.accessToken, headers);
        }

        return headers;
    }

    /**
     *
     */
    addAuthHeader(token, headers = {}) {
        if (token) {
            return this.addHeaderToRequest('Authorization', `Bearer ${token}`, headers);
        }

        return headers;
    }

    /**
     *
     */
    addHeaderToRequest(typeHeader, dataHeader, headers = {}) {
        if (typeHeader) {
            headers[typeHeader] = dataHeader;
        }

        return headers;
    }
}
export default ApiMethods;
